import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCompensationPlan,
  IconPresentation,
  IconMediaKit
} from '../../styles/Icons';

import {
  HeaderIcon,
  ResourcesBody,
  ResourcesContainer,
  ResourcesHeader,
  Title
} from './ResourcesStyled';

export const Resources = () => {
  const { t } = useTranslation('resources');
  return (
    <AnimatedDashboard zoom>
      <PageTitle>{t('resources')}</PageTitle>
      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconPresentation />
            </Icon>
          </HeaderIcon>

          <Title>{t('presentation')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/bigwhale_presentation_ENG.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>{t('project_presentation')}</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/Travelution_Presale_Presentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution Presale Presentation</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>

      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconCompensationPlan />
            </Icon>
          </HeaderIcon>

          <Title>{t('momentum_plan')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/mavie_compensation_plan_long_ENG.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>{t('momentum_plan_presentation')}</li>
          </a>
          <a
            href='https://resources.mavie.global/presentations/mavie_compensation_plan_presentation_ENG.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>{t('momentum_plan_presentation_short')}</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>

      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconMediaKit />
            </Icon>
          </HeaderIcon>

          <Title>{t('videos')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/MaVie_PRESS KIT_ENG.zip'
            target='_blank'
            rel='noreferrer'>
            <li>{t('explainer_video')}</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/BigWhale_PRESS KIT_ENG.zip'
            target='_blank'
            rel='noreferrer'>
            <li>{t('discussing_ultron')}</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>
    </AnimatedDashboard>
  );
};
